//@author: devin

import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { HelpTopic, S25Help } from "./s25.help.service";
import { TypeManagerDecorator } from "../../main/type.map.service";

@TypeManagerDecorator("s25-help-link")
@Component({
    selector: "s25-help-link",
    template: `
        <button
            type="button"
            s25Help
            [helpTopic]="helpTopic"
            class="ngInlineBlock c-help-link-trigger"
            aria-label="Help"
            [class.link]="styleAsLink"
        >
            <ng-content></ng-content>
        </button>
    `,
    styles: `
        button.c-help-link-trigger {
            border: none;
            background: transparent;
            padding: 0;
            margin: 0;
            font: inherit;
            line-height: inherit;
            text-align: inherit;
            cursor: pointer;
            appearance: none;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25HelpComponent implements OnInit {
    @Input() helpTopic: HelpTopic;
    @Input() styleAsLink: boolean = false;

    constructor(private elementRef: ElementRef) {}

    ngOnInit() {
        this.elementRef.nativeElement.angBridge = this;
    }
}
